import { Component } from '@angular/core';

import { RendererBaseComponent } from 'sc-common';

@Component({
    templateUrl: './paper-authors-first-name-renderer.component.html',
    standalone: false
})
export class PaperAuthorsFirstNameRendererComponent extends RendererBaseComponent {

    constructor() {
        super();
    }
}
